import {
  ChangeDetectionStrategy,
  Component, ContentChild, EventEmitter, forwardRef, Host, Inject, Input, OnInit, Optional, Output, Self, TemplateRef,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor, NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgControl,
  ValidationErrors, Validator,
  Validators
} from "@angular/forms";

require('./bringoz-select.scss');
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-bringoz-select',
  templateUrl: './bringoz-select.html',
})
export class BringozSelectComponent implements ControlValueAccessor, Validator, OnInit {

  @Input() selectedValue: string | { label: string, value: any };
  @Input() bindValue?: string;
  @Input() bindLabel?: string;
  @Input() options: string[] | { label: string, value: any }[];
  @Input() required = false;
  @Input() placeholder: string;
  @Input() appendTo?: string;
  @Output() onValueChange = new EventEmitter<string>();

  @ContentChild('ngLabelTmp', {static: false}) labelTemplate!: TemplateRef<any>;
  @ContentChild('ngOptionTmp', {static: false}) optionTemplate!: TemplateRef<any>;

  constructor(@Optional() @Self() @Inject(NgControl) public control: NgControl) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  ngOnInit() {
  }

  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onChange = (value: any) => {
  };
  onTouched = () => {
  };

  onSelectionChange(value: any) {
    this.selectedValue = value;
    this.onChange(value);
    this.onTouched();
    this.onValueChange.emit(value);
  }

  getValidator() {
    return Validators.compose([Validators.required]);
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    const validator = this.getValidator?.();
    if (!validator) {
      return null;
    }
    return validator(control);
  }


  customSearch(term: string, item: any): boolean {
    if (!term) {
      return true;
    }

    term = term.toLowerCase();

    // If item is a string or number, perform a normal includes check
    if (typeof item === 'string' || typeof item === 'number') {
      return item.toString().toLowerCase().includes(term);
    }

    // If item is an object, check every key's value
    if (typeof item === 'object' && item !== null) {
      return Object.values(item).some(value =>
        value && value.toString().toLowerCase().includes(term)
      );
    }

    return false; // Return false if the type is not handled
  }


}
